<script>
export default {
  name: "index",

  components: {
    AddFriends: () => import("./add-friends.vue"),
    ChallengeFriends: () => import("./challenge-friends.vue"),
    Notifications: () => import("./notifications.vue"),
    PrivateRooms: () => import("./private-rooms.vue"),
  },

  data: () => ({
    tabs: [
      {
        text: "Challenge Friends",
        value: "ChallengeFriends",
        to: "challenge",
      },
      {
        text: "Private Rooms",
        value: "PrivateRooms",
        to: "privaterooms",
      },
      {
        text: "Add Friends",
        value: "AddFriends",
        to: "addfriends",
      },
      {
        text: "Notifications",
        value: "Notifications",
        to: "notifications",
      },
    ],

    selectedTab: null,
  }),
};
</script>

<template>
  <section class="pvp-lg h-100">
    <v-row class="text-center pb-2 pb-md-4 pb-lg-10 pt-1">
      <v-toolbar class="dashboard-toolbar challenge-friends-tabs" elevation="8">
        <v-tabs
          icons-and-text
          :fixed-tabs="$vuetify.breakpoint.smAndDown"
          v-model="selectedTab"
        >
          <v-tabs-slider color="transparent"></v-tabs-slider>
          <v-tab
            v-for="(tab, index) in tabs"
            :key="index"
            :to="`/challengefriends/${tab.to}`"
            exact
            class="text-subtitle-2 text-md-h6 bold caf-tab px-1"
            v-ripple="{
              class: 'test'
            }"
          >
            <div v-html="tab.text"/>
          </v-tab>
        </v-tabs>
      </v-toolbar>
    </v-row>

    <v-tabs-items v-model="selectedTab" touchless>
      <v-tab-item
        v-for="(tab, index) in tabs"
        :key="index"
        :value="`/challengefriends/${tab.to}`"
      >
        <component
          :is="tab.value"
          :key="tab.value"
          v-if="selectedTab === `/challengefriends/${tab.to}`"
        />
      </v-tab-item>
    </v-tabs-items>
  </section>
</template>

<style scoped lang="scss">
.caf-tab {
  div {
    font-size: 10px;
    padding: 0 6px;

    @media screen and (min-width: 400px) {
      font-size: 12px;
      padding: 0 10px;
    }

    @media screen and (min-width: 600px) {
      font-size: inherit;
      padding: 0 12px;
    }
  }
}

.caf-bg {
  background: linear-gradient(180deg, rgba(74,47,112,1) 0%, rgba(111,91,155,1) 71%);
}

.tabTitle {
  position: relative;
  z-index: 2 !important;

  @media screen and (max-width: 600px) {
    font-size: 10px;

    @media screen and (max-width: 400px){
      font-size: 8px;
    }
  }
}

.challenge-friends-tabs {
  @media screen and (max-width: 992px) {
    margin-top: 10px;
  }
}

.v-tabs-items {
  background: transparent !important;
}
</style>
